/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Text, Pressable, Icon } from '@components/atoms'
import { motion } from 'framer-motion'

import { grey } from '@mui/material/colors'

interface PropsType {
	title: string
	show: boolean
	onToggleToast: (isShow: boolean) => void
}

export const Toast = (props: PropsType) => {
	// state
	const [show, setShow] = React.useState(false)

	let timeout: ReturnType<typeof setTimeout>

	React.useLayoutEffect(() => {
		if (show) {
			timeout = setTimeout(() => {
				toastRemover()
				clearTimeout(timeout)
			}, 3000)
		}
	}, [show])

	React.useLayoutEffect(() => {
		setShow(props.show)
	}, [props.show])

	const toastRemover = () => {
		setShow(false)

		if (typeof props.onToggleToast === 'function') {
			props.onToggleToast(false)
		}

		clearTimeout(timeout)
	}

	return (
		<motion.div
			css={style}
			initial={{ opacity: 0, bottom: '-5rem', y: '100%' }}
			animate={
				show
					? { opacity: 1, bottom: '3rem', y: 0 }
					: { opacity: 0, bottom: '-5rem', y: '100%' }
			}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.5, type: 'spring' }}
		>
			<Pressable className="toastButton" onClick={toastRemover}>
				<Text className="message">{props.title}</Text>
				<Icon name="close" className="closeIcon" />
			</Pressable>
		</motion.div>
	)
}

const style = css({
	position: 'absolute',
	zIndex: 10,
	width: 'fit-content',
	height: 40,
	left: 0,
	right: 0,
	bottom: '3rem',
	margin: 'auto',

	'.toastButton': {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		paddingLeft: '1rem',
		paddingRight: '1rem',
		backgroundColor: grey[900],
		borderRadius: 40,

		'.message': {
			color: '#FFF',
		},

		'.closeIcon': {
			marginLeft: '0.5rem',
			color: '#FFF',
		},
	},
})
